import axios from 'axios';
import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import PersonOutlineIcon from "@material-ui/icons/PersonOutline";
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const ProfileContainer = styled.div`
  flex: 6;
  margin-top: 70px;
`;

const Profile = () => {
  const [TeacherData, setTeacherData] = useState([])
  const userName = localStorage.getItem('Username')
  console.log('userName', userName)
  useEffect(() => {
    axios({
      method: "get",
      url: `http://localhost:82/Bmu_backend/teacherprofile.php?Username=${userName}`,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then(function (response) {
        //handle success
        setTeacherData(response.data.data)
        console.log(response);
        // setSubmit("Submit");
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });
  }, [])

  console.log('TeacherData', TeacherData)


  return (
    <>
      <ProfileContainer>
        <section >
          <h3 className='m-2'>Profile Section</h3>
          <div className="container py-4">
            <div className="row">
              <div className="col-sm-3">
                <div className="card mb-4">
                  <div className="card-body text-center">
                    <img
                      src={TeacherData.Gender === 'female'

                        ? 'images/teacher1.jpg'
                        : 'images/sir.png'
                      }
                      alt="avatar"
                      className="rounded-circle img-fluid"
                      style={{ width: 220, height: 220 }}
                    />
                    <h5 className="my-3">{TeacherData.Username}</h5>
                    <p className="text-muted mb-1">{TeacherData.Designation}</p>
                  </div>
                  <div class="d-flex justify-content-center mb-4">
                    <Link to="/Changepassword" className="link">    <button type="button" className="btn btn-primary ">Change password</button></Link>
                  </div>
                </div>

              </div>
              <div className="col-lg-8">
                <div className="card mb-4">
                  <div className="card-body">
                    <div className="row">
                      <div className="d-flex ">
                        <PersonOutlineIcon className=" me-2 " />
                        <p className="mb-15" style={{ fontWeight: "500" }}>
                          Personal  Details
                        </p>
                      </div>
                      <hr />
                    </div>
                    <div className="row">
                      <div className="col-sm-3">
                        <p className="mb-0">Full Name</p>
                      </div>
                      <div className="col-sm-9">
                        <p className="text-muted mb-0">{TeacherData.FullName}  </p>
                      </div>
                    </div>
                    <hr />

                    <div className="row">
                      <div className="col-sm-3">
                        <p className="mb-0">Gender</p>
                      </div>
                      <div className="col-sm-9">
                        <p className="text-muted mb-0">{TeacherData.Gender}</p>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <p className="mb-0">Username</p>
                      </div>
                      <div className="col-sm-9">
                        <p className="text-muted mb-0">{TeacherData.Username}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card mb-4">
                  <div className="card-body">
                    <div className="d-flex ">
                      <PersonOutlineIcon className=" me-2 " />
                      <p className="mb-15" style={{ fontWeight: "500" }}>
                        Academic Details
                      </p>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <p className="mb-0">Designation</p>
                      </div>
                      <div className="col-sm-9">
                        <p className="text-muted mb-0">{TeacherData.Designation}</p>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <p className="mb-0">Department</p>
                      </div>
                      <div className="col-sm-9">
                        <p className="text-muted mb-0">{TeacherData.Department}</p>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <p className="mb-0">Email</p>
                      </div>
                      <div className="col-sm-9">
                        <p className="text-muted mb-0">{TeacherData.Email}</p>
                      </div>
                    </div>
                    <hr />
                    <div className="row">
                      <div className="col-sm-3">
                        <p className="mb-0">Mobile NO</p>
                      </div>
                      <div className="col-sm-9">
                        <p className="text-muted mb-0">{TeacherData.Mobile_no}</p>
                      </div>
                    </div>
                  </div>
                </div>





              </div>



            </div>
          </div>
        </section>
      </ProfileContainer>


    </>
  );
}
export default Profile

